import SmallLoader from '../Loader/SmallLoader';

const Preloader = () => (
  <div className="text-center pad-top50"><SmallLoader isLoading size={50} /></div>
);

export default Preloader;
